<template>
	<div>
		<!-- 面包屑 -->
		<Breadcrumb></Breadcrumb>
		<el-card class="mt-2">
			<!-- 搜索框 -->
			 <el-form v-show="showSearch" ref="queryForm" :model="queryForm" inline size="small">
				<el-form-item label="名称" label-width="50px" prop="keyword">
				  <el-input v-model="queryForm.keyword" placeholder="请输入名称" type="text" clearable style="width: 230px" />
				</el-form-item>
				<el-form-item>
				  <el-button type="primary" icon="el-icon-search" size="mini" @click="query">查询</el-button>
				  <el-button icon="el-icon-refresh" size="mini" @click="resetQuery('queryForm')">重置</el-button>
				</el-form-item>
			</el-form>
			<!--自定义刷新组件-->
			<el-row :gutter="10" class="mb-1">
				<el-button type="primary" icon="el-icon-plus" size="mini" @click="handleSel">选择产品</el-button>
				<right-toolbar :show-search.sync="showSearch" @queryTable="query" />
			</el-row>
			<!--表格-->
			 <el-table
				v-loading="loading"
				size="small"
				:data="list"
				element-loading-text="Loading"
				highlight-current-row
				style="width: 100%"
			 >
				<el-table-column label="序号" width="80" align="center">
				  <template slot-scope="scope">
					{{ (queryForm.page - 1) * queryForm.limit + scope.$index + 1 }}
				  </template>
				</el-table-column>
				<el-table-column label="活动名称" min-width="110" align="center">
				  <template slot-scope="scope">
					<span>{{ scope.row.name }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="封面" min-width="110" align="center">
				  <template slot-scope="scope">
					<img :src="scope.row.url" style="width: 50px;height: 50px;" @click="viewImage(scope.row,'url')" v-if="scope.row.url">
					<img src="@/assets/images/empty.png" style="width: 50px;height: 50px;" v-else>
				  </template>
				</el-table-column>
				<el-table-column label="商品名称" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.goods_name }}
				  </template>
				</el-table-column>
				<el-table-column label="商品价格" min-width="110" align="center">
				  <template slot-scope="{row, $index}">
						<div @click.stop="{{changeState2($index,'price','editPriceInput')}}">
						<el-input
						  v-if="editable[$index]"
						  v-model="row.price"
						  size="mini"
						  class="editPriceInput"
						></el-input>
						<span v-else>{{row.price}}</span>
						</div>
				  </template>
				</el-table-column>
				<el-table-column label="上线" min-width="60" align="center">
					<template slot-scope="scope">
						<el-switch
						 v-model="scope.row.status"
						 @change="changeStatus(scope.row,'status')"
						 active-color="#13ce66"
						 :active-value="1"
						 :inactive-value="2">
						 </el-switch>
					</template>
				</el-table-column>
				<el-table-column label="推荐" min-width="60" align="center">
					<template slot-scope="scope">
						<el-switch
						 v-model="scope.row.is_rec"
						 @change="changeStatus(scope.row,'is_rec')"
						 active-color="#13ce66"
						 :active-value="1"
						 :inactive-value="2">
						 </el-switch>
					</template>
				</el-table-column>
				<el-table-column label="热门" min-width="60" align="center">
				  <template slot-scope="scope">
				  	<el-switch
				  	 v-model="scope.row.is_hot"
				  	 @change="changeStatus(scope.row,'is_hot')"
				  	 active-color="#13ce66"
				  	 :active-value="1"
				  	 :inactive-value="2">
				  	 </el-switch>
				  </template>
				</el-table-column>
				<el-table-column label="新品" min-width="60" align="center">
				  <template slot-scope="scope">
				  	<el-switch
				  	 v-model="scope.row.is_new"
				  	 @change="changeStatus(scope.row,'is_new')"
				  	 active-color="#13ce66"
				  	 :active-value="1"
				  	 :inactive-value="2">
				  	 </el-switch>
				  </template>
				</el-table-column>
				<el-table-column align="center" prop="utime" label="时间" min-width="170">
				  <template slot-scope="scope">
					<i class="el-icon-time" />
					<span>{{ scope.row.ctime }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="操作" min-width="100" align="center" fixed="right">
				  <template slot-scope="scope">
				<!-- 	<el-tooltip class="item" effect="dark" content="编辑" placement="top">
					  <el-button type="success" icon="el-icon-edit" size="mini" circle @click="handleEdit(scope.row)"></el-button>		
		            </el-tooltip> -->
					<el-tooltip class="item" effect="dark" content="删除" placement="top">
					  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="handleDelete(scope.row.id)"></el-button>		
					</el-tooltip>
				  </template>
				</el-table-column>
			 </el-table>
			 <pagination
				:total="total"
				auto-scroll
				:page.sync="queryForm.page"
				:limit.sync="queryForm.limit"
				@pagination="query"
			 />
		</el-card>
		<!-- 选择商品 -->
		<el-dialog :visible.sync="openGoods" width="800px" :close-on-click-modal="false" append-to-body :title="title">
			<div class="w-100 flex align-center">
				<!-- 搜索框 -->
				 <el-form ref="tableForm" :model="tableForm" inline size="small">
					<el-form-item label="商品类型" label-width="70px" prop="cat_id">
						<el-select v-model="tableForm.cat_id" placeholder="请选择商品类型" size="medium" class="w-100">
							<el-option label="无" :value="0"></el-option>
							<el-option v-for="(item,index) in goods_cat" :key="index"
								:label="item | tree" 
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="产品名称" label-width="70px" prop="keyword">
					  <el-input v-model="tableForm.keyword" placeholder="请输入名称" type="text" clearable />
					</el-form-item>
					<el-form-item>
					  <el-button type="primary" icon="el-icon-search" size="mini" @click="getGoods">查询</el-button>
					  <el-button icon="el-icon-refresh" size="mini" @click="resetTableQuery('tableForm')">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
		    <el-table
			   ref="dataTable"
			  :data="goodsData"
			  @selection-change="handleSelectionChange"
			  style="width: 100%">
			  <el-table-column
				type="selection"
				width="55">
			  </el-table-column>
			  <el-table-column
			  label="ID"
			  align="center"
			  prop="id">
			  </el-table-column>
			  <el-table-column
			  prop="url"
			  align="center"
			  label="封面">
			  <template slot-scope="scope">
			   <img :src="scope.row.url" style="width: 30px;height: 30px;cursor: pointer;" @click="viewImage(scope.row,'url')" v-if="scope.row.url">
			   <img src="@/assets/images/empty.png" style="width: 30px;height: 30px;cursor: pointer;" v-else>
			  </template>
			  </el-table-column>
			  <el-table-column
			  label="名称"
			  align="center"
			  prop="name">
			  </el-table-column>
			  <el-table-column
			  label="分类"
			  align="center"
			  prop="p_cate_name">
			  </el-table-column>
			  <el-table-column
			  label="价格"
			  align="center"
			  prop="price">
			  <template slot-scope="{row, $index}">
					<div @click.stop="{{changeState($index,'price','editPriceInput')}}">
					<el-input
					  v-if="editable[$index]"
					  v-model="row.price"
					  size="mini"
					  class="editPriceInput"
					></el-input>
					<span v-else>{{row.price}}</span>
					</div>
			  </template>
			  </el-table-column>
			  <el-table-column
			  label="市场价"
			  align="center"
			  prop="mktprice">
			  </el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer flex-all">
			  <el-button type="danger" size="medium" @click="handleAllSubmit" style="width: 200px;">确 定</el-button>
			</div>
			<!-- 分页 -->
			<span slot="footer" class="dialog-footer">
			  <div class="px-2" style="flex: 1;">
			   <pagination
				 :total="goods_page.total"
				 auto-scroll
				 :page.sync="goods_page.page"
				 :limit.sync="goods_page.limit"
				 @pagination="getGoods"
			   />
			  </div>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import GlobalTips from "@/components/GlobalTips";
	import Breadcrumb from '@/components/Breadcrumb';
	import common from "@/common/mixins/common.js"
	export default {
		inject:['app'],
		mixins:[common],
		components: {
			GlobalTips,
			Breadcrumb,
		},
		data() {
			return {
				title:'',
				preUrl: 'promotion_goods',
				autoRequest: false,
				queryForm: {
					page: 1,
					limit: 10,
					keyword: '',
		            id:'',
				},
				tableForm:{
					page: 1,
					limit: 10,
					keyword: '',
					cat_id:'',
				},
				goods_page: {
					page: 1,
					limit: 10,
					total:0,
					keyword: '',
				},
				openGoods:false,
				goodsData:[],
				ids:[],
				goods_cat:[],
				id:'',
			}
		},
		mounted() {
			if(this.$route.query.id){
				this.id = this.$route.query.id
				this.queryForm.id = this.$route.query.id
				this.getList()
			}
			this.getGoodsCat()
		},
		filters: {
			tree(item) {
				if (item.level == 0) {
					return item.name
				}
				let str = ''
				for (let i = 0; i < item.level; i++) {
					str += i == 0 ? '|--' : '--'
				}
				return str + ' ' +item.name;
			}
		},
		methods:{
			getGoodsCat(){
				this.axios.get('/manage/goods_cat/list').then(res=>{
					if(res.status){
						let data = res.data
						let index = data.findIndex((v)=>v.id === 3)
						data.splice(index,1)
						this.goods_cat = data
					}
				})
			},
			handleSel(id){
				this.getGoods()
				this.$nextTick(()=>{
				  this.title = '商品列表'
				  this.openGoods = true
				  this.id = id
				})
			},
			getGoods(){
				this.axios.get('/manage/goods/sel_goods',{
				  params: {
					page:this.goods_page.page,
					limit:this.goods_page.limit,
					keyword:this.tableForm.keyword,
					cat_id:this.tableForm.cat_id
				  }
				}).then(res=>{
				  this.goods_page.total = res.data.total
				  this.goodsData = res.data.list
				  // 默认选中
				  this.getData()
				})
			},
			handleGoodsSel(index,item){
				this.form.value = item.id
				this.openGoods = false
				this.title = '新增'
			},
			handleSelectionChange(e){
				let ids = [];
				if(e.length > 0){
					e.forEach((item)=>{
						ids.push({'id':item.id,'price':item.price});
					})
				}
				this.ids = ids
			},
			handleAllSubmit(){
				this.$confirm('确定要添加吗？', '提示', {
				  confirmButtonText: '添加',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
				  this.loading = true
				  this.axios.post('/manage/promotion/add_goods',{
					   ids:this.ids,
					   id:parseInt(this.queryForm.id),
					}).then(res => {
						if (res.status) {
						  this.$message({
							message: '添加成功',
							type: 'success'
						  })
						  this.getList()
						}
						this.openGoods = false
						this.loading = false
				  }).catch(err => {
					   this.loading = false
				  })
				})
			},
			changeState(index, name, className) {
			  this.editable = new Array(this.goodsData.length)
			  this.editable[index] = true
			  this.saveItem = this.goodsData[index]
			  this.$set(this.editable, index, true)
			  // 让input自动获取焦点
			  this.$nextTick(function() {
				var editInputList = document.getElementsByClassName(className)
				const input = editInputList[0].children[0]
				input.focus()
				input.onblur = (e) => {
				  this.$set(this.editable, index, false)
				  this.ids[index].price = this.saveItem['price']
				}
			  })
			},
			changeState2(index, name, className) {
			  this.editable = new Array(this.list.length)
			  this.editable[index] = true
			  this.saveItem = this.list[index]
			  this.$set(this.editable, index, true)
			  // 让input自动获取焦点
			  this.$nextTick(function() {
				var editInputList = document.getElementsByClassName(className)
				const input = editInputList[0].children[0]
				input.focus()
				input.onblur = (e) => {
				  this.changeItem(name, this.list[index])
				  this.$set(this.editable, index, false)
				}
			  })
			},
			changeItem(name, item) {
			  this.axios.post('/manage/'+this.preUrl + '/changeState', {
			    id: item.id,
			    name: name,
			    value: item[name]
			  }, {
			    token: true
			  }).then(res => {
			    const result = res.data
			    if (result.status) {
			      // 成功后
			    }
			  })
			},
			getData(){
				this.axios.post('/manage/promotion/get_goods',{
				   id:parseInt(this.queryForm.id),
				}).then(res => {
					if (res.status) {
						let list = []
						let rows = res.data.list
						if(rows.length>0){
							this.goodsData.forEach((item) => {
								rows.forEach(val => {
									if (val.goods_id === item.id) {
										list.push(item)
									}
							   })
							})
						}
						console.log(list)
						if (list) {
							list.forEach((row) => {
							  this.$refs.dataTable.toggleRowSelection(row, true)
							})
						}
					}
				})
			},
		}
	}
</script>

<style>
</style>